
import { motion } from 'framer-motion';

export default function Solution() {
  return (
    <section id="funktionen" className="py-24 px-6 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#0066FF]/5 rounded-full blur-[120px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="inline-block px-4 py-2 bg-[#0066FF]/10 border border-[#0066FF]/20 rounded-full mb-6">
            <span className="text-sm font-semibold text-[#0066FF]">Komplette Business Suite</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Alles, was du für deinen Erfolg brauchst
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Eine zentrale Plattform mit allen Tools und Funktionen, die du als SuperOne-Partner benötigst
          </p>
        </motion.div>

        {/* Main Feature Categories */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Leadgenerierung */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-gray-800"
          >
            <div className="w-16 h-16 bg-green-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-user-add-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Leadgenerierung</h3>
            <p className="text-gray-400 mb-6">
              Generiere automatisch qualifizierte Leads über verschiedene Kanäle
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">Personalisierte Landingpages</div>
                  <div className="text-gray-400 text-xs">Für B2C über Social Media & Ads</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">B2B Branchen-Suche</div>
                  <div className="text-gray-400 text-xs">Finde lokale Unternehmen automatisch</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">KI-gestützte Analyse</div>
                  <div className="text-gray-400 text-xs">Automatische Lead-Qualifizierung</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* CRM & Management */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-gray-800"
          >
            <div className="w-16 h-16 bg-[#0066FF] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-dashboard-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">CRM & Management</h3>
            <p className="text-gray-400 mb-6">
              Verwalte alle Leads zentral und behalte den Überblick
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">Zentrales Dashboard</div>
                  <div className="text-gray-400 text-xs">Alle Leads auf einen Blick</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">Status-Pipeline</div>
                  <div className="text-gray-400 text-xs">Von Neu bis Konvertiert</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">Aktivitäten & Notizen</div>
                  <div className="text-gray-400 text-xs">Dokumentiere alle Interaktionen</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Automatisierung & KI */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-gray-800"
          >
            <div className="w-16 h-16 bg-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-robot-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Automatisierung & KI</h3>
            <p className="text-gray-400 mb-6">
              Spare Zeit durch intelligente Automatisierung
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">E-Mail Templates</div>
                  <div className="text-gray-400 text-xs">Vorgefertigte Vorlagen nutzen</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">KI-Vorschläge</div>
                  <div className="text-gray-400 text-xs">Intelligente Empfehlungen</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <div>
                  <div className="text-white font-medium text-sm">Automatische Analysen</div>
                  <div className="text-gray-400 text-xs">Website & Social Media Prüfung</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Detailed Features Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h3 className="text-3xl font-bold text-white text-center mb-12">Alle Funktionen im Detail</h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Feature Cards */}
            {[
              {
                icon: 'ri-pages-line',
                title: 'Landingpages',
                description: 'Individuelle Links für Social Media',
                color: 'green'
              },
              {
                icon: 'ri-search-line',
                title: 'B2B-Suche',
                description: 'Lokale Unternehmen finden',
                color: 'blue'
              },
              {
                icon: 'ri-mail-line',
                title: 'E-Mail Templates',
                description: 'Professionelle Vorlagen',
                color: 'yellow'
              },
              {
                icon: 'ri-phone-line',
                title: 'Kontaktdaten',
                description: 'Automatische Extraktion',
                color: 'red'
              },
              {
                icon: 'ri-line-chart-line',
                title: 'Analytics',
                description: 'Performance-Tracking',
                color: 'purple'
              },
              {
                icon: 'ri-team-line',
                title: 'Team-Management',
                description: 'Mehrere Nutzer verwalten',
                color: 'cyan'
              },
              {
                icon: 'ri-file-list-line',
                title: 'Lead-Scoring',
                description: 'Automatische Bewertung',
                color: 'orange'
              },
              {
                icon: 'ri-graduation-cap-line',
                title: 'Schulungen',
                description: 'Umfassende Tutorials',
                color: 'pink'
              }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 border border-gray-800 hover:border-gray-700 transition-all"
              >
                <div className={`w-12 h-12 bg-${feature.color}-500/20 rounded-xl flex items-center justify-center mb-4`}>
                  <i className={`${feature.icon} text-${feature.color}-400 text-xl`}></i>
                </div>
                <h4 className="text-white font-bold mb-2">{feature.title}</h4>
                <p className="text-gray-400 text-sm">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-r from-[#0066FF] to-[#0052CC] rounded-3xl p-12 text-center"
        >
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Bereit, durchzustarten?
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Starte jetzt kostenlos und entdecke alle Funktionen der SuperOne Business Suite
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a 
              href="/registrieren"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#0066FF] rounded-lg hover:bg-gray-100 transition-all text-lg font-semibold whitespace-nowrap cursor-pointer shadow-lg"
            >
              Jetzt kostenlos starten
              <i className="ri-arrow-right-line"></i>
            </a>
            <a 
              href="#funktionsweise"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg hover:bg-white/20 transition-all text-lg font-semibold whitespace-nowrap cursor-pointer"
            >
              Mehr erfahren
              <i className="ri-information-line"></i>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
